# todo i18n
# скорее всего надо вообще убрать шаблоны зон доставки
TEMPLATES = []
[
  {
    name: 'Садовое кольцо'
    description: 'г. Москва'
    area: [
      [ 37.593657727381185, 55.76788719757305 ]
      [ 37.590739483972996, 55.7657581216823 ]
      [ 37.58576130404134, 55.76120925017479 ]
      [ 37.58335804476402, 55.75317483499864 ]
      [ 37.58335804476402, 55.74465460339584 ]
      [ 37.58610462679526, 55.73836005053253 ]
      [ 37.59863590731284, 55.73390482773902 ]
      [ 37.61116718783042, 55.73003030582132 ]
      [ 37.626960034510105, 55.73003030582132 ]
      [ 37.638289685389005, 55.73148329679708 ]
      [ 37.64944767489096, 55.7384568975302 ]
      [ 37.655627484461284, 55.74417044322162 ]
      [ 37.65665745272299, 55.75511099066462 ]
      [ 37.658030743738614, 55.75917660340805 ]
      [ 37.655627484461284, 55.765371004429866 ]
      [ 37.64704441561363, 55.76953231260657 ]
      [ 37.6398346377816, 55.77146765279925 ]
      [ 37.628239255606076, 55.773159526252 ]
      [ 37.61793957298888, 55.773546565839894 ]
      [ 37.60626659935608, 55.77325628651083 ]
      [ 37.598541837393185, 55.77093397372006 ]
      [ 37.593657727381185, 55.76788719757305 ]
    ].map((c) => c.reverse())
  },
  {
    name: 'МКАД'
    description: 'г. Москва'
    area: [
      [ 37.39074574059143, 55.84725551885814 ]
      [ 37.39211903160705, 55.823297364674275 ]
      [ 37.381132703482045, 55.79932438465565 ]
      [ 37.37014637535704, 55.778432608687 ]
      [ 37.36877308434141, 55.745137286414575 ]
      [ 37.38937244957581, 55.707936683243524 ]
      [ 37.41271839684142, 55.68621989080121 ]
      [ 37.4388109261383, 55.655174878410676 ]
      [ 37.497862439810184, 55.60389650871587 ]
      [ 37.591246228872684, 55.57434202255773 ]
      [ 37.69286976402892, 55.57434202255773 ]
      [ 37.76016102379456, 55.60778359308751 ]
      [ 37.831572156607045, 55.65129251234899 ]
      [ 37.82745228356018, 55.69165022489676 ]
      [ 37.83981190270081, 55.7590783374564 ]
      [ 37.838438611685184, 55.81401926045554 ]
      [ 37.81646595543517, 55.83721035566725 ]
      [ 37.70934925621642, 55.88972545112034 ]
      [ 37.63656483238831, 55.89821384180734 ]
      [ 37.58025990074768, 55.9097859149277 ]
      [ 37.5321947152008, 55.90438604560784 ]
      [ 37.474516492544545, 55.885094633797 ]
      [ 37.4223314339508, 55.874287235373004 ]
      [ 37.39074574059143, 55.84725551885814 ]
    ].map((c) => c.reverse())
  },
  {
    name: 'ТТК'
    description: 'г. Москва'
    area: [
      [ 37.55425514221182, 55.77495166750233 ]
      [ 37.56318153381337, 55.78423912350916 ]
      [ 37.5745111846923, 55.79197697219763 ]
      [ 37.58618415832509, 55.79197697219763 ]
      [ 37.60026039123526, 55.792170398638795 ]
      [ 37.61605323791495, 55.79294409475705 ]
      [ 37.63218940734853, 55.792170398638795 ]
      [ 37.63768257141104, 55.791783544791805 ]
      [ 37.64695228576651, 55.79352435671705 ]
      [ 37.652445449829, 55.793137516375005 ]
      [ 37.65725196838368, 55.7904295259406 ]
      [ 37.6627451324462, 55.78559335845421 ]
      [ 37.66995491027823, 55.781143551832386 ]
      [ 37.678194656371964, 55.777854236299454 ]
      [ 37.683687820434486, 55.775145178842905 ]
      [ 37.68952430725089, 55.770887706458225 ]
      [ 37.69295753478995, 55.76837170779988 ]
      [ 37.69364418029776, 55.75559566033966 ]
      [ 37.69673408508292, 55.75075515060677 ]
      [ 37.70016731262198, 55.74726961006304 ]
      [ 37.69810737609855, 55.742621736176 ]
      [ 37.69810737609855, 55.73758591200135 ]
      [ 37.70119728088368, 55.73448661890845 ]
      [ 37.71184028625478, 55.725574774513646 ]
      [ 37.71046699523915, 55.72305583951227 ]
      [ 37.694674148559464, 55.71840506924299 ]
      [ 37.68609107971181, 55.71627328031596 ]
      [ 37.678194656371964, 55.71297846759391 ]
      [ 37.66995491027823, 55.710071048122714 ]
      [ 37.65725196838368, 55.70309235479637 ]
      [ 37.62154640197744, 55.705806439826674 ]
      [ 37.61639656066884, 55.70270461290975 ]
      [ 37.61159004211416, 55.70095972660906 ]
      [ 37.606440200805565, 55.701153606728255 ]
      [ 37.58618415832509, 55.70755110881087 ]
      [ 37.578287734985246, 55.7131722878327 ]
      [ 37.57313789367667, 55.71569186305657 ]
      [ 37.566271438598534, 55.71801747994728 ]
      [ 37.55322517395009, 55.72324960953663 ]
      [ 37.54738868713368, 55.72712480725323 ]
      [ 37.54292549133292, 55.733324320280275 ]
      [ 37.53949226379384, 55.73661740945872 ]
      [ 37.53537239074697, 55.74087864011927 ]
      [ 37.531595840453996, 55.75172330081281 ]
      [ 37.53708900451651, 55.76624265848181 ]
      [ 37.53983558654776, 55.768952337349276 ]
      [ 37.54395545959463, 55.77224240742045 ]
      [ 37.55082191467277, 55.774177612491236 ]
      [ 37.55425514221182, 55.77495166750233 ]
    ].map((c) => c.reverse())
  }
]

App.ZoneTemplatesLayerComponent = Em.Component.extend
  classNames: 'zone-templates-layer'

  filterQuery: ''

  store: Em.inject.service('store')

  classNameBindings: ['isShown:shown']
  isShown: false
  restaurant: null

  zoneTemplates: TEMPLATES

  filteredZoneTemplates: (->
    @get('zoneTemplates').filter (zone) =>
      name = Em.get(zone, 'name').toLowerCase()
      query = @get('filterQuery').trim().toLowerCase()
      name.indexOf(query) != -1
  ).property('filterQuery', 'zoneTemplates.[]')

  showLayer: (->
    Em.run.next =>
      @set('isShown', true)
  ).on('didInsertElement')

  hasZoneTemplates: Em.computed.gt('zoneTemplates.length', 0)


  zoneType: 'delivery'

  isDineInAvailable: Em.computed.equal('restaurant.organization.features.dine_in_disabled', false)

  isZoneDelivery: Em.computed.equal('zoneType', 'delivery')
  isZoneTakeaway: Em.computed.equal('zoneType', 'takeaway')
  isZoneDineIn:   Em.computed.equal('zoneType', 'dine_in')

  actions:
    cancel: ->
      @sendAction('onCancel')
      false

    createDineInClicked: ->
      @set('isShown', false)
      zone = @get('store').createRecord 'delivery_zone',
        name          : Em.I18n.t 'zone_templates.new_object_default_name.dine_in'
        area          : null
        organization  : @get('restaurant.organization')
        restaurant    : @get('restaurant')
        takeaway      : false
        dine_in       : true
        delivery_time :      0
        transportation_time: 0
        cooking_time:        0
        price              : 0

      zone.save().then =>
        # send action to DeliveryController
        @sendAction('onTemplateSelected', zone)
      false

    createTakeawayClicked: ->
      @set('isShown', false)
      zone = @get('store').createRecord 'delivery_zone',
        name          : Em.I18n.t 'zone_templates.new_object_default_name.takeaway'
        area          : null
        organization  : @get('restaurant.organization')
        restaurant    : @get('restaurant')
        takeaway      : true
        delivery_time :      0
        transportation_time: 0
        cooking_time:        0
        price              : 0

      zone.save().then =>
        # send action to DeliveryController
        @sendAction('onTemplateSelected', zone)
      false

    templateSelected: (template) ->
      # hide zone-templates layer
      @set('isShown', false)
      # create zone
      zone = @get('store').createRecord 'delivery_zone',
        name          : template.name
        area          : template.area
        organization  : @get('restaurant.organization')
        restaurant    : @get('restaurant')
        delivery_time :      0
        transportation_time: 0
        cooking_time:        0
        price         : 0

      zone.save().then =>
        # send action to DeliveryController
        @sendAction('onTemplateSelected', zone)

    drawClicked: ->
      @set('isShown', false)
      @sendAction('onDrawClicked', @get('restaurant'))
